import { Button, Result, Skeleton } from 'antd';

import { PREFIX } from '@app/constants';

import { useEmailChange } from '@pages/Employees/EmailChange/hooks/useEmailChange';

import type { FC } from 'react';
import '@pages/Employees/EmailChange/styles/EmailChange.mobile.scss';
import '@pages/Employees/EmailChange/styles/EmailChange.desktop.scss';

export const EmailChange: FC = () => {
  const {
    isLoader,
    isEmailChanged,
    newEmail,
    serverError,
    navigateToNextPage,
  } = useEmailChange();

  if (isLoader) {
    return <Skeleton active />;
  }

  return (
    <div className={`${PREFIX}email-change`}>
      <Result
        status={isEmailChanged ? '403' : '404'}
        title={
          isEmailChanged
            ? 'Новый email подтверждён'
            : 'При подтверждении смены Email произошла ошибка'
        }
        subTitle={
          isEmailChanged ? (
            <>
              Смена Вашего email на{' '}
              <b>
                <i>{newEmail}</i>
              </b>{' '}
              подтверждена. Используйте адрес{' '}
              <b>
                <i>{newEmail}</i>
              </b>{' '}
              для входа в Beauty CRM.
            </>
          ) : (
            <>{serverError}</>
          )
        }
        extra={
          <Button
            type="primary"
            onClick={() =>
              navigateToNextPage(
                isEmailChanged ? `/authorization?email=${newEmail}` : '/'
              )
            }
            size="large"
            style={{ marginTop: '30px' }}
          >
            {isEmailChanged ? 'Войти' : 'Главная'}
          </Button>
        }
      />
    </div>
  );
};
